module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-premium-bee58bb5592767c19d8ce0dcb1a2ed9b.jpg";